import React from 'react';
import PropTypes from 'prop-types';
import RenderSectionParagraph from '../RenderSectionParagraph/RenderSectionParagraph';
import rewardHeaderBgImage from '../../../assets/images/gq_background_logo.png';
import classes from './RewardSections.module.scss';

const RewardSections = (props) => {
    const { reward_block } = props?.data || {};

    if (!reward_block?.visible) return null;

    const RenderRewardBlocks = ({ data }) => {
        if (data?.length === 0) return null;

        return (
            <div className={classes.RewardCards}>
                <div className="row">
                    {data?.map((cardData, index) => {
                        return (
                            <div key={`reward-card-${index}`} className="col-lg-4 col-md-4 mx-auto">
                                <div className={classes.RewardCard}>
                                    <img src={cardData?.logo} className={classes.CardImage} alt={cardData?.name} />
                                    <p className={classes.CardTitle}>{cardData?.name}</p>
                                    <p className={classes.CardText}>{cardData?.description}</p>
                                    {cardData?.url ? 
                                        (<a href={cardData?.url} target="_blank" rel='noopener norefer'>
                                            view details
                                        </a>)
                                    : null}
                                </div>
                            </div>
                        )
                    })}
                </div>
            </div>
        )
    }
    
    return (
        <div className={classes.RewardSections}>
            {(reward_block?.title || reward_block?.subtitle) ?
                (<div className={classes.RewardHeaderWrap} style={{ backgroundImage: `url(${rewardHeaderBgImage})` }}>
                    {reward_block?.title ? (<h1 className={classes.Title}>{reward_block?.title}</h1>) : null}
                    {reward_block?.subtitle ? (<p className={classes.Subtitle}>{reward_block?.subtitle}</p>) : null}
                </div>)
            : null}
            {reward_block?.description?.length !== 0 ? <RenderSectionParagraph data={reward_block?.description} /> : null}

            <RenderRewardBlocks data={reward_block?.rewards || []} />
        </div>
    )
}

RewardSections.propTypes = {}

export default RewardSections;